import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import Animation from '../animation';
export var FocusPriorItemOnLoadMore =
/*#__PURE__*/
function (_Animation) {
  _inherits(FocusPriorItemOnLoadMore, _Animation);

  function FocusPriorItemOnLoadMore() {
    _classCallCheck(this, FocusPriorItemOnLoadMore);

    return _possibleConstructorReturn(this, _getPrototypeOf(FocusPriorItemOnLoadMore).apply(this, arguments));
  }

  _createClass(FocusPriorItemOnLoadMore, [{
    key: "shouldAcceptGettingFutureItems",
    value: function shouldAcceptGettingFutureItems(action) {
      return action.payload.loadMoreButtonClicked;
    }
  }, {
    key: "uiDidUpdate",
    value: function uiDidUpdate() {
      var newDays = this.acceptedAction('GOT_DAYS_SUCCESS').payload.internalDays;
      var firstNewItem = newDays[0][1][0];
      var allRegisteredItemComponents = this.registry().getAllItemsSorted();
      var indexOfFirstNewItemComponent = allRegisteredItemComponents.findIndex(function (itemComponent) {
        return itemComponent.componentIds[0] === firstNewItem.uniqueId;
      });
      var indexOfPriorItemComponent = indexOfFirstNewItemComponent - 1;

      if (indexOfPriorItemComponent < 0) {
        console.error('FocusPriorItemOnLoadMore could not find the item that should receive focus');
        return;
      }

      var priorItemComponent = allRegisteredItemComponents[indexOfPriorItemComponent];
      this.animator().focusElement(priorItemComponent.component.getFocusable());
    }
  }]);

  return FocusPriorItemOnLoadMore;
}(Animation);